let isRedirectingToLogin = false;

const getCurrentHashPath = () => {
  const hash = window.location.hash.startsWith("#") ? window.location.hash.slice(1) : window.location.hash;

  return hash === "" ? "/" : hash;
};

const isAuthRoute = (path: string) => {
  return (
    path === "/login" ||
    path.startsWith("/login?") ||
    path.includes("password-reset") ||
    path.includes("accept-invite") ||
    path === "/terminated"
  );
};

export const redirectToLoginAfterUnauthorized = (beforeRedirect?: () => void) => {
  const currentPath = getCurrentHashPath();

  if (isRedirectingToLogin || isAuthRoute(currentPath)) {
    return;
  }

  isRedirectingToLogin = true;

  localStorage.setItem("gotolink", currentPath);
  beforeRedirect?.();
  window.location.href = "#/login";
};

